// test866
(866 && 0);
